module.exports = __webpack_public_path__ + "assets/img/d3.63e6dc48.jpg";